import moment from 'moment';
import React from 'react';

import { Units } from '../../../shared/interfaces';
import { friendlySpeed } from '../../../shared/helpers';
import styles from '../NewPointDetails.module.scss';

export type PointDetailsInfoProps = {
    isEvent: boolean;
    formattedAddress: string;
    dateTime: moment.Moment;
    speed: number;
    units: Units;
    makeModel: string;
    postedSpeed?: number;
    driverName?: string;
};

export const PointDetailsInfo: React.FC<PointDetailsInfoProps> = ({
    isEvent,
    formattedAddress,
    dateTime,
    speed,
    units,
    makeModel,
    postedSpeed,
    driverName
}) => (
    <div className={styles.PointDetailsInfo}>
        {isEvent && (
            <div className={styles.InfoEntry}>
                <span className={styles.Label}>Current Location:</span>
                <span className={styles.InfoData}>{formattedAddress}</span>
            </div>
        )}

        <div className={styles.InfoEntry}>
            <span className={styles.Label}>Date & Time:</span>
            <span className={styles.InfoData}>{dateTime.format('MM/DD/YY h:mm A')} </span>
        </div>

        <div className={styles.InfoEntry}>
            <span className={styles.Label}>Speed:</span>
            <span className={styles.InfoData}>{friendlySpeed(speed, units)}</span>
        </div>

        {makeModel !== '' && (
            <div className={styles.InfoEntry}>
                <span className={styles.Label}>Vehicle:</span>
                <span className={styles.InfoData}>{makeModel}</span>
            </div>
        )}

        {typeof postedSpeed !== 'undefined' && (
            <div className={styles.InfoEntry}>
                <span className={styles.Label}>Posted Speed:</span>
                <span className={styles.InfoData}>{postedSpeed}</span>
            </div>
        )}

        {driverName && (
            <div className={styles.InfoEntry}>
                <span className={styles.Label}>Driver:</span>
                <span className={styles.InfoData}>{driverName}</span>
            </div>
        )}
    </div>
);